import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { FilterSelect } from '@warrenbrasil/nebraska-web';

import { IOrdersListResponseFilters } from '@/modules/wealth/services/wealth-orders';

interface Props {
  disabled?: boolean;
  ordersFilters: IOrdersListResponseFilters | null;
}

interface Emit {
  (
    event: 'on-filter-select',
    filters: { filterKey: string; value: string }
  ): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
    disabled: { type: Boolean, default: false },
    ordersFilters: null
  },
  emits: ["on-filter-select"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'on-filter-select',
    filters: { filterKey: string; value: string }
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, ordersFilters: IOrdersListResponseFilters | null }

const OrdersFiltersKeys: { [key: string]: string } = {
  period: 'Período',
  type: 'Tipo de movimentação'
};

const defaultValues = ['0', 'all'];



function getFilterLabel(filter: string) {
  const selectedFilter = props.ordersFilters![filter].filter(
    filter => filter.selected
  )[0];
  return selectedFilter;
}

function getFilterValue(filter: string) {
  const selectedFilter = getFilterLabel(filter);
  const isDefaultValueSelected = defaultValues.includes(selectedFilter.value);
  return isDefaultValueSelected ? '' : selectedFilter!.value;
}

function getFilterOptions(filter: string) {
  return props.ordersFilters![filter].map(option => {
    return {
      label: option.formatted,
      value: option.value
    };
  });
}

const filters = computed(() => {
  const orderFilters = Object.keys(props.ordersFilters!);
  return orderFilters.map(filter => {
    return {
      value: getFilterValue(filter),
      label: getFilterLabel(filter).formatted,
      key: filter,
      options: getFilterOptions(filter)
    };
  });
});



function handleChange(filterKey = '', value = '') {
  emit('on-filter-select', { filterKey, value });
}

return { __sfc: true,OrdersFiltersKeys, defaultValues, props, getFilterLabel, getFilterValue, getFilterOptions, filters, emit, handleChange, FilterSelect }
}

})